class AllAboutProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelector("#all-about-product--tabs");
    this.imageColumn = document.querySelector("#all-about-product--col-image");
    this.buyButton = document.querySelector(
      ".button.all-about-product--buy-now"
    );
    this.tabs.addEventListener("click", this.tabsEventHandler.bind(this));
    this.buyButton.addEventListener(
      "click",
      this.buyButtonEventHandler.bind(this)
    );
    this.setBackgroundColor();
  }

  disconnectedCallback() {
    this.tabs.removeEventListener("click", this.tabsEventHandler.bind(this));
  }

  tabsEventHandler(event) {
    const newActiveBtn = event.target.closest(".all-about-product--tab-button");
    const { productTabHandle } = newActiveBtn.dataset;

    const prevActiveBtn = this.tabs.querySelector(
      `[data-product-tab-active="true"]`
    );
    const prevActiveTab = this.querySelector(
      `.all-about-product--tab-content[data-product-tab-handle="${prevActiveBtn.dataset.productTabHandle}"]`
    );

    prevActiveBtn.dataset.productTabActive = false;
    prevActiveTab.dataset.productTabActive = false;

    newActiveBtn.dataset.productTabActive = true;
    this.querySelector(
      `.all-about-product--tab-content[data-product-tab-handle="${productTabHandle}"]`
    ).dataset.productTabActive = true;

    this.imageColumn.querySelector(
      `div[data-image-tab-active="true"]`
    ).dataset.imageTabActive = false;
    this.imageColumn.querySelector(
      `div[data-product-tab-handle="${productTabHandle}"]`
    ).dataset.imageTabActive = true;

    this.setBackgroundColor();
  }

  setBackgroundColor() {
    document.querySelector(
      ".shopify-section.all-about-product"
    ).style.backgroundColor = this.querySelector(
      `.all-about-product--tab-content[data-product-tab-active="true"]`
    ).dataset.backgroundColor;
  }

  buyButtonEventHandler(event) {
    const btn = event.target.closest("button.all-about-product--buy-now");
    if (!btn) return;
    document.querySelector("product-info").scrollIntoView({
      behavior: "smooth",
    });
  }
}

customElements.define("all-about-product", AllAboutProduct);
